<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<th>{{ 'adminstat.common.Status' | translate }}</th>
				<th>{{ 'adminstat.billing.billing.tariffInfo' | translate }}</th>
				<th>{{ 'adminstat.billing.billing.mark' | translate }}</th>
				<th>{{ 'adminstat.billing.billing.type' | translate }}</th>
				<th>{{ 'adminstat.billing.billing.dateCreate' | translate }}</th>
				<th>{{ 'adminstat.billing.billing.dateTo' | translate }}</th>
				<th>{{ 'adminstat.billing.billing.usages' | translate }}</th>
				<th>{{ 'adminstat.billing.billing.site list' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let stat of details">
				<td>
					<span *ngIf="! stat.isFlash">
						{{ stat.status }}
					</span>
				</td>
				
				<td>
					<ng-container *ngIf="! stat.isFlash">
						<ngb-accordion #acc="ngbAccordion">
							<ngb-panel [id]="'panel' + i" title="{{ 'adminstat.billing.billing.tariff info' | translate }}">
								<ng-template ngbPanelContent>
									<ng-container *ngFor="let tariffId of stat.discounts | keys">
										<table class="table">
											<thead>
												<tr colspan="4">
													<th>
														{{ tariffId }}
													</th>
												</tr>
											
												<tr>
													<th>
														{{ 'adminstat.billing.billing.tariffVariant' | translate }}
													</th>
													
													<th *ngFor="let currency of currencyList">
														{{ 'adminstat.billing.billing.' + currency.toUpperCase() | translate }}
													</th>
												</tr>
											</thead>
											
											<tbody>
												<ng-container *ngIf="stat.discounts[tariffId]">
													<tr *ngFor="let tariffVariant of stat.discounts[tariffId] | keys">
														<td>
															{{ tariffVariant }}
														</td>
														
														<td *ngFor="let currency of currencyList">
															{{ stat.discounts[tariffId][tariffVariant][currency.toUpperCase()] || 0 }}
														</td>
													</tr>
												</ng-container>
											</tbody>
										</table>
									</ng-container>
								</ng-template>
							</ngb-panel>
						</ngb-accordion>
					</ng-container>
				</td>
				
				<td>
					{{ stat.mark }}
				</td>
				
				<td>
					<span *ngIf="! stat.isFlash">
						{{ stat._type }}
					</span>
				</td>
				
				<td>
					<span *ngIf="! stat.isFlash">
						{{ moment(stat.dateCreate).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm') }}
					</span>
				</td>

				<td>
					<span *ngIf="! stat.isFlash">
						{{ moment(stat.dateTo).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm') }}
					</span>
				</td>
				
				<td>
					<ng-container *ngIf="! stat.isFlash">
						<span *ngIf="stat.maxUsages == 0">
							{{ stat.usages }}
						</span>

						<span *ngIf="stat.maxUsages != 0">
							{{ stat.usages }} / {{ stat.maxUsages }}
						</span>
					</ng-container>
				</td>
				
				<td>
					<ngb-accordion #acc="ngbAccordion">
						<ngb-panel [id]="'a' + i" title="{{ 'adminstat.billing.billing.paids' | translate }} {{ stat.mark }} ({{ stat.siteList.length }})">
							<ng-template ngbPanelContent>
								<ul>
									<li *ngFor="let site of stat.siteList; let i = index">
										{{ i + 1 }})
										<site_info [siteUrl]="site.url"></site_info>
										({{ site.tariffVariant }}) ({{ site.tariffId }}) ({{ moment(site.transaction_date).tz('Europe/Moscow').format('DD.MM.YYYY HH:mm') }})
									</li>
								</ul>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</td>
			</tr>
		</tbody>
	</table>



</info-modal>
